import { render } from "./PunchInOutModal.vue?vue&type=template&id=20da686a&scoped=true"
import script from "./PunchInOutModal.vue?vue&type=script&lang=js"
export * from "./PunchInOutModal.vue?vue&type=script&lang=js"

import "./PunchInOutModal.vue?vue&type=style&index=0&id=20da686a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20da686a"]])

export default __exports__